import { Dropdown } from 'antd'
import { useRouter } from 'next/router'
import { MyIcon } from '~/components/ui/MyIcon'
import useSearchParams from '~/hooks/useSearchParam'
import {
  GET_SIZES,
  GET_ARTWORK_MODELS,
  GET_VISIBLE_LIST,
} from '~/graphqls/gqls'
import {
  getSizes,
  getArtworkModels,
  getArtworkModelsVariables,
  AiCreateArtworkModel,
  getVisibleList,
} from '~/graphqls/types'

import { useImperativeQuery } from '~/hooks/useImperativeQuery'

import styles from './Sort.module.css'
import { useEffect, useState } from 'react'
import classNames from 'classnames'

interface menuTypes {
  key: string
  label: string
}

function Sort({ model }: { model?: AiCreateArtworkModel | null }) {
  const router = useRouter()
  const changeRoute = (obj: Record<string, number | string>) => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          ...obj,
        },
      },
      undefined,
      { shallow: true }
    )
  }
  const {
    sort,
    scope,
    content,
    lang,
    modelType,
    size,
    initImage,
    visibleType,
    isUnderCollection,
    character,
    modelFusion,
  } = useSearchParams()

  const sortMenu = [
    {
      key: '推荐',
      label: '推荐',
    },
    {
      key: '最新',
      label: '最新',
    },
    {
      key: '同款最多',
      label: '同款最多',
    },
    {
      key: '点赞最多',
      label: '点赞最多',
    },
    {
      key: '收藏最多',
      label: '收藏最多',
    },
  ]
  const scopeMenu = [
    {
      key: '全网',
      label: '全网',
    },
    {
      key: '无界词/图',
      label: '无界词/图',
    },
  ]
  const contentMenu = [
    {
      key: '全部',
      label: '全部',
    },
    {
      key: '标题/简介/画面描述',
      label: '标题/简介/画面描述',
    },
    {
      key: '图像信息',
      label: '图像信息',
    },
  ]
  const langMenu = [
    {
      key: '不限',
      label: '不限',
    },
    {
      key: '中文',
      label: '中文',
    },
    {
      key: '英文',
      label: '英文',
    },
  ]
  const initImageMenu = [
    {
      label: '不限',
      key: '不限',
    },
    {
      label: '有',
      key: '有',
    },
    {
      label: '无',
      key: '无',
    },
  ]
  const characterMenu = initImageMenu
  const modelFusionMenu = initImageMenu

  const sizesAction = useImperativeQuery<getSizes>(GET_SIZES)
  const modelAction = useImperativeQuery<
    getArtworkModels,
    getArtworkModelsVariables
  >(GET_ARTWORK_MODELS)

  const visibleAction = useImperativeQuery<getVisibleList>(GET_VISIBLE_LIST)

  const [sizeMenu, setSizeMenu] = useState<menuTypes[]>([])
  const [modelMenu, setModelMenu] = useState<menuTypes[]>([])
  const [visibleMenu, setVisibleMenu] = useState<menuTypes[]>([])

  useEffect(() => {
    try {
      Promise.all([
        sizesAction(),
        modelAction({ model }),
        visibleAction(),
      ]).then(res => {
        setSizeMenu([
          {
            key: '',
            label: '全部',
          },
          ...(res?.[0]?.data?.aiArtworkResourceModule?.sizeList?.map(it => {
            return {
              key: it,
              label: it,
            }
          }) as menuTypes[]),
        ])
        setModelMenu([
          {
            key: '',
            label: '全部',
          },
          ...(res?.[1]?.data?.aiArtworkResourceModule?.modelClassificationList?.map(
            it => {
              return {
                key: it?.ids?.join(','),
                label: it?.name,
              }
            }
          ) as menuTypes[]),
        ])
        const visileList =
          res?.[2]?.data?.squareModule?.postVisibleTypeList?.filter(
            item => item?.value !== '-1' && item?.value !== '2'
          )
        setVisibleMenu([
          {
            key: '',
            label: '不限',
          },
          ...(visileList?.map(it => {
            return {
              key: it?.value,
              label: it?.desc,
            }
          }) as menuTypes[]),
        ])
      })
    } catch (error) {}
  }, [model])

  return (
    <div className="relative flex">
      <Dropdown
        placement="bottomLeft"
        overlayClassName={styles.dropdown}
        menu={{
          items: sortMenu,
          selectedKeys: [sort],
          onClick: item => {
            changeRoute({ sort: item.key })
          },
        }}
      >
        <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
          排序：{sort} <MyIcon icon="arrow-down-simple"></MyIcon>
        </div>
      </Dropdown>

      {!isUnderCollection && (
        <>
          <Dropdown
            className="ml-3"
            placement="bottomRight"
            overlayClassName={styles.dropdown}
            menu={{
              items: scopeMenu,
              selectedKeys: [scope],
              onClick: item => {
                changeRoute({ scope: item.key })
              },
              style: { minWidth: '121px' },
            }}
          >
            <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
              搜索范围：{scope} <MyIcon icon="arrow-down-simple"></MyIcon>
            </div>
          </Dropdown>

          <Dropdown
            className="ml-3"
            placement="bottomRight"
            overlayClassName={styles.dropdown}
            menu={{
              items: contentMenu,
              selectedKeys: [content],
              onClick: item => {
                changeRoute({ content: item.key })
              },
            }}
          >
            <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
              搜索内容：{content} <MyIcon icon="arrow-down-simple"></MyIcon>
            </div>
          </Dropdown>

          <Dropdown
            className="ml-3"
            placement="bottomRight"
            overlayClassName={styles.dropdown}
            menu={{
              items: langMenu,
              selectedKeys: [lang],
              onClick: item => {
                changeRoute({ lang: item.key })
              },
            }}
          >
            <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
              描述语言：{lang} <MyIcon icon="arrow-down-simple"></MyIcon>
            </div>
          </Dropdown>
          {modelMenu.length > 1 && model !== AiCreateArtworkModel.STYLE && (
            <Dropdown
              className="ml-3"
              placement="bottom"
              overlayClassName={classNames(styles.dropdown, {
                [styles.horizontal]: true,
              })}
              menu={{
                items: modelMenu,
                selectedKeys: [modelType || ''],
                onClick: item => {
                  changeRoute({ modeltype: item.key })
                },
              }}
            >
              <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
                模型选择：
                {modelMenu.filter(it => it?.key === modelType)?.[0]?.label ||
                  '全部'}
                <MyIcon icon="arrow-down-simple"></MyIcon>
              </div>
            </Dropdown>
          )}
          {sizeMenu.length > 1 && (
            <Dropdown
              className="ml-3"
              placement="bottomRight"
              overlayClassName={styles.dropdown}
              menu={{
                items: sizeMenu,
                selectedKeys: [size || ''],
                onClick: item => {
                  changeRoute({ size: item.key })
                },
              }}
            >
              <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
                画面尺寸：
                {sizeMenu.filter(it => it?.key === size)?.[0]?.label || '全部'}
                <MyIcon icon="arrow-down-simple"></MyIcon>
              </div>
            </Dropdown>
          )}
          {model !== AiCreateArtworkModel.STYLE && (
            <>
              <Dropdown
                className="ml-3"
                placement="bottomRight"
                overlayClassName={styles.dropdown}
                menu={{
                  items: initImageMenu,
                  selectedKeys: [initImage],
                  onClick: item => {
                    changeRoute({ initImage: item.key })
                  },
                }}
              >
                <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
                  参考图：{initImage} <MyIcon icon="arrow-down-simple"></MyIcon>
                </div>
              </Dropdown>
              {/* 产品不满意当前样式，暂时隐藏 */}
              {/* <Dropdown
                className="ml-3"
                placement="bottomRight"
                overlayClassName={styles.dropdown}
                menu={{
                  items: characterMenu,
                  selectedKeys: [character],
                  onClick: item => {
                    changeRoute({ character: item.key })
                  },
                }}
              >
                <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
                  角色同人：{character}{' '}
                  <MyIcon icon="arrow-down-simple"></MyIcon>
                </div>
              </Dropdown> */}
              {/* <Dropdown
                className="ml-3"
                placement="bottomRight"
                overlayClassName={styles.dropdown}
                menu={{
                  items: modelFusionMenu,
                  selectedKeys: [modelFusion],
                  onClick: item => {
                    changeRoute({ modelFusion: item.key })
                  },
                }}
              >
                <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
                  融合模型：{modelFusion}{' '}
                  <MyIcon icon="arrow-down-simple"></MyIcon>
                </div>
              </Dropdown> */}
            </>
          )}
          <Dropdown
            className="ml-3"
            placement="bottomRight"
            overlayClassName={styles.dropdown}
            menu={{
              items: visibleMenu,
              selectedKeys: [visibleType || ''],
              onClick: item => {
                changeRoute({ visibleType: item.key })
              },
            }}
          >
            <div className="text-neutral-400 font-semibold text-xs flex items-center cursor-pointer">
              公开范围：
              {visibleMenu.filter(it => it?.key == visibleType)?.[0]?.label ||
                '不限'}
              <MyIcon icon="arrow-down-simple"></MyIcon>
            </div>
          </Dropdown>
        </>
      )}
    </div>
  )
}

export default Sort
